import { render, staticRenderFns } from "./RdCosts.vue?vue&type=template&id=b39e2162&"
import script from "./RdCosts.vue?vue&type=script&lang=ts&"
export * from "./RdCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports